import React from "react";
import { PropTypes } from "prop-types";
import { observer } from "mobx-react";
import { UserCertifiedModeInfoModal } from "application/user-settings/components";
import { DeviceSetupFlow, AppBadges, ContentModeControl } from "themes/application/device-settings/components";

function DeviceOnboardingTemplate({ onboardingViewStore, t }) {
    const { modeSelectStore, certifiedModeInfoModal, openCertifiedModeInfoModal } = onboardingViewStore;

    return (
        <div className="c-device-onboarding c-device-onboarding--bento">
            <div className="c-device-onboarding__head">
                <h3 className="c-device-onboarding__title">{t("APPLICATION.DEVICE_SETTINGS.ONBOARDING.TITLE")}</h3>
                <p className="c-device-onboarding__subtitle">
                    {t("APPLICATION.DEVICE_SETTINGS.ONBOARDING.SUBTITLE")}
                </p>
            </div>

            <div className="c-device-onboarding__grid">
                <DeviceSetupFlow t={t} />

                <div className="c-device-onboarding__tile c-device-onboarding__tile--app">
                    <p className="c-device-onboarding__label">
                        {t("APPLICATION.DEVICE_SETTINGS.ONBOARDING.APP.TITLE")}
                    </p>
                    <AppBadges t={t} />
                </div>

                <div className="c-device-onboarding__tile c-device-onboarding__tile--mode">
                    <ContentModeControl
                        modeSelectStore={modeSelectStore}
                        onInfoClick={openCertifiedModeInfoModal}
                        t={t}
                    />
                </div>
            </div>

            <UserCertifiedModeInfoModal modalParams={certifiedModeInfoModal} hideDevicesLink />
        </div>
    );
}

DeviceOnboardingTemplate.propTypes = {
    onboardingViewStore: PropTypes.object.isRequired,
    t: PropTypes.func.isRequired,
};

export default observer(DeviceOnboardingTemplate);
